import { render, staticRenderFns } from "./DialogActionProductEdit.vue?vue&type=template&id=198b32fe&scoped=true"
import script from "./DialogActionProductEdit.vue?vue&type=script&lang=js"
export * from "./DialogActionProductEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b32fe",
  null
  
)

export default component.exports